import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Fragment } from 'react';

interface WizardStepperProps {
  steps: string[];
  currentStep: number; // 0-indexed
}

export function WizardStepper({ steps, currentStep }: WizardStepperProps) {
  return (
    <div className="flex items-center justify-center mb-10">
      {steps.map((label, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;

        return (
          <Fragment key={label}>
            <div className="flex flex-col items-center">
              <div
                className={cn(
                  'w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold border-2 transition-all duration-300',
                  isCompleted && 'bg-emerald-500 border-emerald-500 text-white',
                  isActive && 'bg-brand-gradient border-transparent text-white',
                  !isCompleted && !isActive && 'border-slate-200 text-slate-400 bg-white'
                )}
              >
                {isCompleted ? <Check className="w-4 h-4" strokeWidth={3} /> : index + 1}
              </div>
              <span
                className={cn(
                  'mt-2 text-xs font-medium hidden sm:block',
                  isActive ? 'text-slate-900' : 'text-slate-500'
                )}
              >
                {label}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={cn(
                  'w-16 sm:w-24 h-0.5 mx-2 sm:mx-4 rounded-full transition-colors duration-300',
                  index < currentStep ? 'bg-emerald-500' : 'bg-slate-200'
                )}
              />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}
